"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var parse_exports = {};
__export(parse_exports, {
  isValidQualificationRole: () => isValidQualificationRole,
  optParseQualificationRole: () => optParseQualificationRole,
  parseQualificationRole: () => parseQualificationRole,
  qualificationRoleName: () => qualificationRoleName,
  roleQualificationId: () => roleQualificationId
});
module.exports = __toCommonJS(parse_exports);
var import_util = require("@cartographerio/util");
var import_core = require("../../core/index.js");
var import_types_generated = require("../types.generated.js");
function optParseQualificationRole(role) {
  const parts = role.split(":");
  switch (parts[0]) {
    case "Q":
      return parts.length === 3 && (0, import_types_generated.isQualificationRoleName)(parts[1]) && (0, import_core.isQualificationId)(parts[2]) ? [parts[1], parts[2]] : null;
    default:
      return null;
  }
}
function parseQualificationRole(role) {
  return optParseQualificationRole(role) ?? (0, import_util.raise)(new Error(`Bad qualification role: ${role}`));
}
function isValidQualificationRole(role) {
  return optParseQualificationRole(role) != null;
}
function qualificationRoleName(role) {
  const parts = optParseQualificationRole(role);
  return parts?.[0] ?? null;
}
function roleQualificationId(role) {
  const parts = optParseQualificationRole(role);
  return parts?.[1] ?? null;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  isValidQualificationRole,
  optParseQualificationRole,
  parseQualificationRole,
  qualificationRoleName,
  roleQualificationId
});
//# sourceMappingURL=parse.js.map
